// removed by extract-text-webpack-plugin
module.exports = {"block":"ScrollCarousel__block-9GC0p","content":"ScrollCarousel__content-1aTeM","slide":"ScrollCarousel__slide-23iK2"};